import React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";

const UserTable = ({ userList, columns }) => {
  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          maxWidth: { xs: 650, sm: 682, lg: 1350 },
          bgcolor: "background.paper",
        }}
      >
        <DataGrid
          rows={userList}
          columns={columns}
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          disableSelectionOnClick
        />
      </Box>
    </>
  );
};

export default UserTable;
